import React, {memo} from "react"
import {MANIFEST} from "@manifest/product-summary"
import {formatTextTestIds} from "@next/utils"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

interface SuitTitleProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    title: string
    tooltipTitle: string
}

export const SuitTitle = memo(({templating, title, tooltipTitle}: SuitTitleProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)
    return (
        <ComponentName
            variant="body1"
            title={tooltipTitle}
            data-testid={formatTextTestIds(`suit_summary_title`)}
            data-label={title}
            data-desc={title}
            data-usespan="False"
        >
            {title}
        </ComponentName>
    )
})
SuitTitle.displayName = "SuitTitle"

export default connect(SuitTitle)
